/* Fehler auf Deutsch, ohne technische Details. Meldungen aus unseren RPCs sind schon Deutsch und werden durchgereicht. */

interface MitCode {
  code?: unknown;
  status?: unknown;
  message?: unknown;
  name?: unknown;
}

const EIGENE_CODES = new Set(["42501", "P0002", "23505", "22023", "P0001"]);

export function fehlertext(e: unknown): string {
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return "Kein Netz. Deine Änderung ist nicht gespeichert. Versuch es noch einmal, sobald du wieder online bist.";
  }
  const f = (typeof e === "object" && e !== null ? e : {}) as MitCode;
  const code = typeof f.code === "string" ? f.code : "";
  const status = typeof f.status === "number" ? f.status : 0;
  const message = typeof f.message === "string" ? f.message : "";

  if (code === "otp_expired") return "Der Code ist falsch oder abgelaufen. Prüf die Ziffern oder fordere einen neuen Code an.";
  if (status === 429 || code.startsWith("over_")) return "Zu viele Versuche. Warte ein paar Minuten und versuch es dann noch einmal.";
  if (EIGENE_CODES.has(code) && message) return message;
  if (code === "42501") return "Dafür fehlt dir das Recht.";
  if (message === "Failed to fetch" || f.name === "TypeError" || message.includes("NetworkError")) {
    return "Keine Verbindung. Deine Änderung ist nicht gespeichert. Versuch es gleich noch einmal.";
  }
  return "Das hat nicht geklappt. Versuch es noch einmal.";
}
